// extracted by mini-css-extract-plugin
export var button = "_mp-0";
export var donut = "_mp-1";
export var donutFill = "_mp-3";
export var donutTrack = "_mp-2";